import { Fold, Lens } from "@discovery/prelude/lib/control/lens";
import * as Optics from "@discovery/sonic-api-ng-optics";
import { optional, record, string, boolean, } from "@discovery/prelude/lib/data/validated";
import * as M from "@discovery/prelude/lib/data/maybe";
export const ContestSteps = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Fold.liftM((description, title) => ({
    description,
    title,
}), Fold.compose(Optics._ColAttributes2Description, M._Just()), Fold.compose(Optics._ColAttributes2Title, M._Just())));
const customAttrValidator = optional(record({
    externalAction: string,
}));
export const GiftingInquiry = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Fold.pre(Optics._GetCustomAttributesForComponent(customAttrValidator)), M._Just(), M._Just(), Lens.prop("externalAction"));
const activeContestIDValidator = optional(record({
    activeContestID: string,
}));
export const activeContestID = Fold.compose(Fold.pre(Optics._GetCustomAttributesForComponent(activeContestIDValidator)), M._Just(), M._Just(), Lens.prop("activeContestID"));
const skipContactDetailValidator = optional(record({
    skipContactDetails: boolean,
}));
export const _SkipContactDetail = Fold.compose(Fold.pre(Optics._GetCustomAttributesForComponent(skipContactDetailValidator)), M._Just(), M._Just(), Lens.prop("skipContactDetails"));

